import { useState } from 'react';
import { getCookie } from '@/helpers/common';
import { COOKIE_NAME } from '@/helpers/cookie';
import { Modals } from '@/helpers/modals';
import { useNavigation } from '@/hooks/navigation';
import { useGetCommonStore } from '@/store';
import { useModalsStore } from '@/store/modalsStore';
import { getCtaButtonHrefWithSessionId } from '../helpers/common';
import { useIsRegModalFlow } from './useIsRegModalFlow';

export const useButtonAction = (afterRegistrationRedirect?: string) => {
  const open = useModalsStore.use.open();
  const { navigate } = useNavigation();
  const [isLoading, setIsLoading] = useState(false);
  const useCommonStore = useGetCommonStore();
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const regBanner = useCommonStore.use.regBanner();

  const isRegModalFlow = useIsRegModalFlow() || regBanner?.isSportsPromo;

  const buttonAction = {
    onClick: () => {
      // Returning visitor who already has an account — show the sign-in modal
      const hasAccount =
        !isAuthenticated && getCookie(COOKIE_NAME.IS_REGISTERED) === 'true';

      if (hasAccount) {
        navigate('/?modal=login', false, true);
        return;
      }

      if (isRegModalFlow && !isAuthenticated) {
        open(Modals.Registration);
        afterRegistrationRedirect &&
          useCommonStore.setState({
            gameOpenBackUrl: '/',
            afterAdditionalDataRedirectUrl: afterRegistrationRedirect,
            afterRegistrationRedirectUrl: afterRegistrationRedirect,
          });
        return;
      }

      setIsLoading(true);
      useCommonStore.setState({ registrationTheme: 'default' });
      navigate(getCtaButtonHrefWithSessionId(afterRegistrationRedirect));
    },
  };
  return { buttonAction, isLoading };
};
